import { render, staticRenderFns } from "./SetSession.vue?vue&type=template&id=6b0f64f6&scoped=true"
import script from "./SetSession.vue?vue&type=script&lang=js"
export * from "./SetSession.vue?vue&type=script&lang=js"
import style0 from "./SetSession.vue?vue&type=style&index=0&id=6b0f64f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0f64f6",
  null
  
)

export default component.exports